<template>
  <b-container fluid>
    <h1>Monthly Report: Regional Coordinator Performance</h1>
    <b-container fluid v-if="optionsLoaded">
      <b-row>
        <b-col>
          <b-select v-model="country" @change="switchOption();" class="mb-4">
            <b-select-option value="">Choose country...</b-select-option>
            <b-select-option v-for="c in countries" :key="c" :value="c">{{ c }}</b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <b-select v-if="country" v-model="period" @change="switchOption();" class="mb-4">
            <b-select-option v-for="value, key in dateOptions" :key="key" :value="key">{{ value }}</b-select-option>
          </b-select>
        </b-col>
      </b-row>
    </b-container>
    <rc-performance-data :country="country" :period="period" :key="country + '_' + period"></rc-performance-data>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import RcPerformanceData from '@/components/RcPerformanceData';

export default {
  name: 'RCPerformance',
  components: { RcPerformanceData },
  data() {
    return {
      country: '',
      period: '',
      urlParams: new URLSearchParams(window.location.search),
      optionsLoaded: false,
    };
  },
  created() {
    this.getOptions();
    if (this.urlParams.get('country') !== null) {
      this.country = this.urlParams.get('country');
    }
    if (this.urlParams.get('period') !== null) {
      this.period = this.urlParams.get('period');
    } else {
      this.period = this.getCurrentPeriod();
    }
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
    }),
    async getOptions() {
      try {
        await this.GET_OPTIONS();

        this.optionsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },
    getCurrentPeriod() {
      let today = new Date();
      return today.getFullYear() + (today.getMonth() < 6 ? 'H1' : 'H2');
    },
    setUrlParam(param, value) {
      this.urlParams.set(param, value);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
    deleteUrlParam(param) {
      this.urlParams.delete(param);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
    switchOption() {
      if (this.country) {
        this.setUrlParam('country', this.country);
      } else {
        this.deleteUrlParam('country');
        this.period = this.getCurrentPeriod();
      }
      if (this.period) {
        this.setUrlParam('period', this.period);
      } else {
        this.deleteUrlParam('period');
      }
    },
  },
  computed: {
    dateOptions: {
      get() {
        let todayDate = new Date(),
          currentYear = todayDate.getFullYear(),
          currentMonth = todayDate.getMonth(),
          options = {};
        for (let y = 2020; y < currentYear; y++) {
          options[`${y}H1`] = `${y} (January – June)`;
          options[`${y}H2`] = `${y} (July – December)`;
        }
        options[`${currentYear}H1`] = `${currentYear} (January – June)`;
        if (currentMonth >= 6) {
          options[`${currentYear}H2`] = `${currentYear} (July – December)`;
        }
        return options;
      },
    },
    countries: {
      get() {
        return this.$store.state.optionsList.countries.sort();
      }
    },
  },
};
</script>
